import config from '../config.json';


const environment = process.env.REACT_APP_ENV;
const baseApiUrl = environment && environment in config ? config[environment].apiUrl : config.dev.apiUrl;

export default baseApiUrl;